
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from "react-i18next";

interface TaskFiltersProps {
  statusFilter: string;
  priorityFilter: string;
  onStatusChange: (value: string) => void;
  onPriorityChange: (value: string) => void;
}

export const TaskFilters = ({
  statusFilter,
  priorityFilter,
  onStatusChange,
  onPriorityChange,
}: TaskFiltersProps) => {
  const { t } = useTranslation('offerManagement');
  
  return (
    <div className="flex space-x-4">
      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[180px] bg-white">
          <SelectValue placeholder={t('tasks.filter.all')} />
        </SelectTrigger>
        <SelectContent className="bg-white">
          <SelectItem value="all">{t('tasks.filter.all')}</SelectItem>
          <SelectItem value="todo">{t('tasks.filter.todo')}</SelectItem>
          <SelectItem value="in_progress">{t('tasks.filter.inProgress')}</SelectItem>
          <SelectItem value="in_review">{t('tasks.filter.inReview')}</SelectItem>
          <SelectItem value="completed">{t('tasks.filter.completed')}</SelectItem>
          <SelectItem value="blocked">{t('tasks.filter.blocked')}</SelectItem>
        </SelectContent>
      </Select>

      <Select value={priorityFilter} onValueChange={onPriorityChange}>
        <SelectTrigger className="w-[180px] bg-white">
          <SelectValue placeholder={t('tasks.priority.all')} />
        </SelectTrigger>
        <SelectContent className="bg-white">
          <SelectItem value="all">{t('tasks.priority.all')}</SelectItem>
          <SelectItem value="low">{t('tasks.priority.low')}</SelectItem>
          <SelectItem value="medium">{t('tasks.priority.medium')}</SelectItem>
          <SelectItem value="high">{t('tasks.priority.high')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
